import { useQuery } from "react-query";
import { useAuth0 as useAuth } from "@auth0/auth0-react";

const REFRESH_INTERVAL_TIMEOUT = 1e3 * 60 * 60;

export const myFetch = async (input, options) =>
  new Promise((resolve, reject) =>
    fetch(input, options)
      .then(async (r) => {
        if (r.ok) {
          const contentType =
            r.headers.get("Content-Type") ||
            r.headers.get("content-type") ||
            "";

          if (contentType.includes("application/json")) {
            resolve(r.json());
          } else if (
            contentType.includes("application/octet-stream") ||
            contentType.includes("image/")
          ) {
            resolve(r.blob());
          } else {
            resolve(r.text());
          }
        } else {
          const msg = await r.text();
          reject(new Error(msg));
        }
      })
      .catch((r) => reject(r.target))
  );

export const endpointPath = (urlPath) => {
  var baseurl = process.env.REACT_APP_API_HOST;
  if (!baseurl || baseurl === "") {
    baseurl = "https://telemetry-backend.tools.elembio.io";
  }
  return baseurl + "/api" + urlPath;
};
export const fetchWithToken = async (
  getAccessTokenSilently,
  urlPath,
  options
) => {
  const token = await getAccessTokenSilently();

  const fullurl = endpointPath(urlPath);
  return myFetch(fullurl, {
    headers: { Authorization: `Bearer ${token}` },
    ...options,
  });
};

export const useFetch = (
  urlPath,
  enabled = true,
  refetchInterval = REFRESH_INTERVAL_TIMEOUT
) => {
  const { getAccessTokenSilently } = useAuth();
  return useQuery(
    urlPath,
    () => fetchWithToken(getAccessTokenSilently, urlPath),
    {
      refetchInterval,
      refetchOnWindowFocus: false,
      // The urlPath check belongs here rather than inside the query function.
      // While it lived in the function, the "nothing to fetch" branch had to
      // invent a return value and returned `() => []` — a function, not data.
      // Gating on `enabled` means react-query never runs the query at all, so
      // `data` stays undefined: the same state every caller already handles
      // when it passes enabled=false.
      enabled: enabled && !!urlPath,
    }
  );
};
